export const TrainingSessionChallengeResultStatus = Object.freeze({
    CLEARED: "cleared",
    NOT_CLEARED: "not cleared",
    NOT_AVAILABLE: "not available",
    ERROR: "error",
    PROCESSING: "processing",
});
export type TrainingSessionChallengeResultStatus =
    (typeof TrainingSessionChallengeResultStatus)[keyof typeof TrainingSessionChallengeResultStatus];

export const TrainingSessionChallengeStatusEnum = Object.freeze({
    COMPLETE: "COMPLETED",
    NOT_COMPLETE: "NOT COMPLETED",
});
export type TrainingSessionChallengeStatusEnum =
    (typeof TrainingSessionChallengeStatusEnum)[keyof typeof TrainingSessionChallengeStatusEnum];

export interface TrainingSessionEvaluationItem {
    behavior: string;
    content: string;
    behaviorPresent: number;
}

export interface TrainingSessionEvaluationResults {
    SessionId?: string;
    Overview: string;
    Timestamp?: string;
    Body: TrainingSessionEvaluationItem[];
    Results: TrainingSessionChallengeResultStatus;
}

export interface TrainingSession {
    challengeCompleted: boolean;
    challengeId: string;
    challengeStatus: TrainingSessionChallengeStatusEnum;
    challengeTaken: boolean;
    evaluationDetails: TrainingSessionEvaluationResults[];
}

export interface CreateTrainingSessionRequest {
    SessionID: string;
    AppId: string;
    ChallengeId: string;
    ChallengeStatus: TrainingSessionChallengeStatusEnum;
    EmployeeId: string | null;
    SessionStartTime: string;
    Environment: "dev" | "prod";
    /** Reference to the profile's simulation in an external system. Omitted when the profile has none. */
    SimulationId?: string;
}

// Hits the training-session "update" route, which does a partial UpdateItem keyed by SessionID: only the
// fields present are written and the rest of the item is left intact. A session-end update needs just
// SessionID + SessionEndTime; the legacy Home flow additionally persists the challenge result. Everything
// other than SessionID + SessionEndTime is therefore optional.
export interface UpdateTrainingSessionRequest {
    SessionID: string;
    ChallengeId?: string;
    ChallengeStatus?: TrainingSessionChallengeStatusEnum;
    EmployeeId?: string | null;
    SessionEndTime: string;
}
